import sc, { css } from 'styled-components';

export interface TitleProps {
  color?: string;
}

export interface TextProps extends TitleProps {
  marginBottom?: true | number;
}

const noMargin = css`
  margin: 0;
`;

const marginStyles = ({ marginBottom }: { marginBottom?: true | number }): string | undefined => {
  if (!marginBottom) {
    return undefined;
  }

  return `margin-bottom: ${marginBottom === true ? '10px' : `${marginBottom}px`};`;
};

const Headline = sc.h1<TitleProps>`
  ${noMargin}
  ${({ theme }) => theme.typography.headline}
  ${({ color }) =>
    color && {
      color,
    }}
`;

const Title = sc.h3<TitleProps>`
  ${noMargin}
  ${({ theme }) => theme.typography.title}
  ${({ color }) =>
    color && {
      color,
    }}
`;

const SubTitle = sc.h5<TitleProps>`
  ${noMargin}
  ${({ theme }) => theme.typography.titleSub}
  ${({ color }) =>
    color && {
      color,
    }}
`;

const TextLarge = sc.p<TextProps>`
  ${noMargin}
  ${({ theme }) => theme.typography.textLarge}
  ${marginStyles}
  & b, strong {
    ${({ theme }) => theme.typography.weightMedium}
  }
  ${({ color }) =>
    color && {
      color,
    }}
`;

const TextMedium = sc.p<TextProps>`
  ${noMargin}
  ${({ theme }) => theme.typography.textMedium}
  ${marginStyles}
  & b, strong {
    ${({ theme }) => theme.typography.weightMedium}
  }
  ${({ color }) =>
    color && {
      color,
    }}
`;

const TextSmall = sc.p<TextProps>`
  ${noMargin}
  ${({ theme }) => theme.typography.textSmall}
  ${marginStyles}
  & b, strong {
    ${({ theme }) => theme.typography.weightMedium}
  }
  ${({ color }) =>
    color && {
      color,
    }}
`;

const TextExtraSmall = sc.p<TextProps>`
  ${noMargin}
  ${({ theme }) => theme.typography.textExtraSmall}
  ${marginStyles}
  & b, strong {
    ${({ theme }) => theme.typography.weightMedium}
  }
  ${({ color }) =>
    color && {
      color,
    }}
`;

type TypographyComponent = (() => null) & {
  Headline: typeof Headline;
  Title: typeof Title;
  SubTitle: typeof SubTitle;
  TextLarge: typeof TextLarge;
  TextMedium: typeof TextMedium;
  TextSmall: typeof TextSmall;
  TextExtraSmall: typeof TextExtraSmall;
};

const Typography = (() => null) as TypographyComponent;

Typography.Headline = Headline;
Typography.Title = Title;
Typography.SubTitle = SubTitle;
Typography.TextLarge = TextLarge;
Typography.TextMedium = TextMedium;
Typography.TextSmall = TextSmall;
Typography.TextExtraSmall = TextExtraSmall;

export default Typography;
